import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Purchase from "../pages/purchase/page";
import About from "../pages/about/page";
import ContactPage from '../pages/contact/page';
import AdminPage from "../pages/admin/page";
import LoginPage from "../pages/login/page";
import AgentLoginPage from "../pages/agent-login/page";
import AgentDashboardPage from "../pages/agent-dashboard/page";
import MessagesPage from "../pages/messages/page";
import ContactMessagesPage from "../pages/contact-messages/page";
import AuroraCardPage from "../pages/aurora-card/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import LendingPage from "../pages/lending/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/purchase",
    element: <Purchase />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/messages",
    element: <MessagesPage />,
  },
  {
    path: "/contact-messages",
    element: <ContactMessagesPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/agent-login",
    element: <AgentLoginPage />,
  },
  {
    path: "/agent-dashboard",
    element: <AgentDashboardPage />,
  },
  {
    path: "/aurora-card",
    element: <AuroraCardPage />,
  },
  {
    path: "/lending",
    element: <LendingPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
